import { useAppRouter } from "../hooks/useAppRouter";

interface PayrollNotificationProps {
	onComplete?: () => void;
}

export function PayrollNotification({ onComplete }: PayrollNotificationProps) {
	const router = useAppRouter();

	const handleCompletePayroll = () => {
		// Navigate to payroll data screen
		router.navigateWithCheck("app-payroll-data");
		onComplete?.();
	};

	return (
		<div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4 cursor-pointer" onClick={handleCompletePayroll}>
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-1">
					<svg className="w-5 h-5 text-yellow-800" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
						/>
					</svg>
					<div>
						<h3 className="text-sm font-semibold text-yellow-800">
							Lohn- und Steuerdaten unvollständig
						</h3>
						<p className="text-sm text-yellow-700">
							Bitte vervollständigen Sie Ihre Lohn- und Steuerdaten.
						</p>
					</div>
				</div>
				
				<button className="bg-yellow-200 hover:bg-yellow-300 text-yellow-800 text-xs font-medium px-3 py-1.5 rounded-md transition-colors">
					Hier klicken
				</button>
			</div>
		</div>
	);
}
